import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

import { Button } from '@/components/shadcn/button'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/shadcn/collapsible'
import { cn } from '@/lib/utils'

import { BankReconReferenceIndexEntry } from './types'

export function BankReconReferenceIndex({ entries }: { entries: BankReconReferenceIndexEntry[] }) {
  const [open, setOpen] = useState(false)

  if (entries.length === 0) return null

  return (
    <div className="mt-3 space-y-2 px-1">
      <p className="text-xs font-semibold uppercase tracking-wide">Reference index</p>
      <p className="text-xs text-muted-foreground">
        What every reference code in this table represents. Derived rows show how they are composed from other refs.
      </p>
      <Collapsible open={open} onOpenChange={setOpen}>
        <CollapsibleTrigger asChild>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-7 gap-1.5 rounded-full px-3 text-xs font-normal"
          >
            <ChevronDown
              className={cn('size-3.5 shrink-0 text-muted-foreground transition-transform', open && 'rotate-180')}
              aria-hidden
            />
            {entries.length} references
          </Button>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <ul className="mt-2 divide-y divide-border rounded-md border bg-background text-xs">
            {entries.map((entry) => (
              <li key={entry.ref} className="grid grid-cols-[minmax(3rem,auto)_1fr] items-start gap-x-4 px-3 py-2.5">
                <span className="font-semibold tabular-nums text-foreground">{entry.ref}</span>
                <span className="text-muted-foreground">{entry.description ?? '—'}</span>
              </li>
            ))}
          </ul>
        </CollapsibleContent>
      </Collapsible>
    </div>
  )
}
